module.exports = __webpack_public_path__ + "img/building.7f25d840.svg";